import analytic from '@src/assets/composting/analytic.png'
import food from '@src/assets/composting/food.png'
import leftovers from '@src/assets/composting/leftovers.png'
import location from '@src/assets/composting/location.png'
import napkins from '@src/assets/composting/napkins.png'
import recycle from '@src/assets/composting/recycle.png'

/**
 * Tile icons for the composting <FeatureGrid> sections, keyed by the `icon`
 * string in commercial-composting-data.json / commercial-composting-austin-data.json.
 *
 * The six PNGs the React app served from Firebase Storage (`assets/landing/*.png`
 * on the trash-warrior bucket), re-hosted here: recycle / location / analytic
 * for the benefits band, leftovers / napkins / food for the accepted-materials
 * band. Both composting pages run the same two bands, so both use all six.
 */
const compostingIcons: Record<string, { src: string }> = {
  recycle,
  location,
  analytic,
  leftovers,
  napkins,
  food,
}

/**
 * Resolves the JSON `icon` keys of a FeatureGrid list to asset URLs. Unknown or
 * missing keys drop the icon rather than rendering a broken image.
 */
export function withCompostingIcons<T extends { icon?: string }>(list: T[]) {
  return list.map((item) => ({ ...item, icon: compostingIcons[item.icon ?? '']?.src }))
}

export default compostingIcons
